unit DonationDefaults;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, WebForm.Core, Vcl.StdCtrls, WEBLib.StdCtrls,
  Vcl.Controls, WEBLib.ExtCtrls, Data.DB, XData.Web.JsonDataset,
  XData.Web.Dataset, WEBLib.DB, WEBLib.DBCtrls;

type
  TDonationDefaultsForm = class(TCoreWebForm)
    PaymentMethodDefaultCombo: TLookupComboBox;
    AmountDefaultEdit: TEdit;
    DayOfMonthDefaultEdit: TEdit;
    DonationKindDefaultCombo: TLookupComboBox;
    SaveDefaultButton: TButton;
    CancelDefaultButton: TButton;
    CloseDefaultButton: TButton;
    DonationDefaults: TXDataWebDataSet;
    DonationDefaultsId: TIntegerField;
    DonationDefaultsDateAdded: TDateTimeField;
    DonationDefaultsAddedBy: TIntegerField;
    DonationDefaultsLastUpdatedBy: TIntegerField;
    DonationDefaultsLastUpdated: TDateTimeField;
    DonationDefaultsDonorId: TIntegerField;
    DonationDefaultsDonationKind: TStringField;
    DonationDefaultsUsualDayOfMonth: TIntegerField;
    DonationDefaultsAmount: TFloatField;
    DonationDefaultsPaymentMethod: TStringField;
    DonationDefaultsAnalysisCode1: TStringField;
    DonationDefaultsAnalysisCode2: TStringField;
    DonationDefaultsAnalysisCode3: TStringField;
    AnalysisCode1DefaultCombo: TDBComboBox;
    DonationDefaultsDataSource: TDataSource;
    AnalysisCode2DefaultCombo: TDBComboBox;
    BankingReferenceDefaultCombo: TDBComboBox;
    DonationDefaultsBankingReference: TStringField;
    DonationDefaultsOtherDonationKind: TStringField;
    OtherDonationKindDefaultEdit: TDBEdit;
    procedure WebFormShow(Sender: TObject);
    procedure CloseDefaultButtonClick(Sender: TObject);
    procedure SaveDefaultButtonClick(Sender: TObject);
    procedure DonationDefaultsAfterPost(DataSet: TDataSet);
    procedure DonationDefaultsAfterOpen(DataSet: TDataSet);
    procedure DataChange(Sender: TObject);
    procedure DonationDefaultsAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure DonationDefaultsDataSourceDataChange(Sender: TObject;
      Field: TField);
    procedure DayOfMonthDefaultEditChange(Sender: TObject);
    procedure DayOfMonthDefaultEditKeyPress(Sender: TObject; var Key: Char);
    procedure AmountDefaultEditKeyPress(Sender: TObject; var Key: Char);
    procedure CancelDefaultButtonClick(Sender: TObject);
    procedure DonationKindDefaultComboChange(Sender: TObject);
    procedure OtherDonationKindDefaultEditExit(Sender: TObject);
    procedure WebFormCreate(Sender: TObject);

  private
    { Private declarations }
    FDonorId: integer;
    procedure SetLookups;
    procedure SetDonorId(ADonorId: integer);
    procedure SaveDefaults;
    procedure PopulateForm;
    procedure Refresh;
    [Async]
    procedure LoadDefaults; async;
    procedure DetermineOtherDonationKindVisibility;
  public
    { Public declarations }

    property DonorId: integer read FDonorId write SetDonorId;
  protected procedure LoadDFMValues; override; end;

var
  DonationDefaultsForm: TDonationDefaultsForm;

implementation

uses
  MainDataModule,
  Essentials.Web.Shared, Essentials.Web.Manager, GA.Web.Utils,
  SMX.Web.Document.Utils;


{$R *.dfm}

procedure TDonationDefaultsForm.AmountDefaultEditKeyPress(Sender: TObject;
  var Key: Char);
begin
  if not (Key in ['0'..'9','.']) then
    Key := #0;
end;

procedure TDonationDefaultsForm.CancelDefaultButtonClick(Sender: TObject);
begin
  DonationKindDefaultCombo.ItemIndex := -1;
  OtherDonationKindDefaultEdit.Text := '';
  DayOfMonthDefaultEdit.Text      := '';
  AmountDefaultEdit.Text          := '';
  PaymentMethodDefaultCombo.ItemIndex := -1;
  AnalysisCode1DefaultCombo.ItemIndex := -1;
  AnalysisCode2DefaultCombo.ItemIndex := -1;
  SaveDefaultButton.Enabled := False;
  CancelDefaultButton.Enabled := False;
end;

procedure TDonationDefaultsForm.CloseDefaultButtonClick(Sender: TObject);
begin
  ModalResult := mrClose;
end;

procedure TDonationDefaultsForm.SetDonorId(ADonorId: integer);
begin
  FDonorId := ADonorId;
  LoadDefaults;
end;

procedure TDonationDefaultsForm.WebFormCreate(Sender: TObject);
begin
  inherited;
  DetermineOtherDonationKindVisibility;
end;

procedure TDonationDefaultsForm.WebFormShow(Sender: TObject);
begin
  SetLookups;
  SaveDefaultButton.Enabled := False;
end;

procedure TDonationDefaultsForm.SetLookups;
begin
(*  DonationKindDefaultCombo.LookupValues.AddPair('Donation', 'Donation');
  DonationKindDefaultCombo.LookupValues.AddPair('GiveAsYouEarn', 'Give As You Earn');
  DonationKindDefaultCombo.LookupValues.AddPair('PayrollGiving', 'Payroll Giving');
  DonationKindDefaultCombo.LookupValues.AddPair('PayrollGovernmentScheme', 'Payroll Government Scheme');
  DonationKindDefaultCombo.LookupValues.AddPair('Legacy', 'Legacy');
  DonationKindDefaultCombo.LookupValues.AddPair('Other', 'Other'); *)
  TDonationUIUtils.AddDonationKindLookupsToCombo(DonationKindDefaultCombo.LookupValues);
  TDonationUIUtils.AddPaymentMethodLookupsToCombo(PaymentMethodDefaultCombo.LookupValues);
(*
  PaymentMethodDefaultCombo.LookupValues.AddPair('Cash', 'Cash');
  PaymentMethodDefaultCombo.LookupValues.AddPair('Card', 'Card');
  PaymentMethodDefaultCombo.LookupValues.AddPair('Cheque', 'Cheque');
  PaymentMethodDefaultCombo.LookupValues.AddPair('StandingOrder', 'Standing Order');
  PaymentMethodDefaultCombo.LookupValues.AddPair('DDR', 'DDR');
  PaymentMethodDefaultCombo.LookupValues.AddPair('BankTransfer', 'Bank Transfer');
  PaymentMethodDefaultCombo.LookupValues.AddPair('PayPal', 'PayPal');
  PaymentMethodDefaultCombo.LookupValues.AddPair('WebCard', 'Web Card');
  PaymentMethodDefaultCombo.LookupValues.AddPair('Other', 'Other');*)

  DonationKindDefaultCombo.ItemIndex := -1;
  PaymentMethodDefaultCombo.ItemIndex := -1;
end;


procedure TDonationDefaultsForm.DonationDefaultsAfterApplyUpdates(
  Sender: TDataSet; Info: TResolveResults);
begin
//  inherited;
  Refresh;
end;

procedure TDonationDefaultsForm.DonationDefaultsAfterOpen(DataSet: TDataSet);
begin
  if DonationDefaults.Locate('DonorId', FDonorId, []) then
  begin
    PopulateForm;
    DonationDefaults.Edit
  end
  else
    DonationDefaults.Insert;
end;

procedure TDonationDefaultsForm.DonationDefaultsAfterPost(DataSet: TDataSet);
begin
  //inherited;
  DonationDefaults.ApplyUpdates;
end;

procedure TDonationDefaultsForm.DonationDefaultsDataSourceDataChange(
  Sender: TObject; Field: TField);
begin
  inherited;
  DataChange(Sender);
end;

procedure TDonationDefaultsForm.DonationKindDefaultComboChange(Sender: TObject);
begin
  inherited;
  DataChange(Sender);
  DetermineOtherDonationKindVisibility;
  if DonationKindDefaultCombo.Value <> TDOnationUIUtils.OTHER then
    DonationDefaults.FieldByName('OtherDonationKind').AsString := '';
end;

procedure TDonationDefaultsForm.LoadDefaults; {$IFDEF PAS2JS}async;{$ENDIF}
begin
  Await(DonationDefaults.Load);
  EssentialsManager.AddEntitySetMappings([TLookupMapping.Create('DonationDefaults', 'Donation')]);
  EssentialsManager.FormSetUp(Self);
end;

procedure TDonationDefaultsForm.OtherDonationKindDefaultEditExit(
  Sender: TObject);
begin
  if OtherDonationKindDefaultEdit.Enabled = False then
    DonationDefaults.FieldByName('OtherDonationKind').AsString := '';
end;

procedure TDonationDefaultsForm.SaveDefaultButtonClick(Sender: TObject);
begin
  SaveDefaults;
  SaveDefaultButton.Enabled := False;
end;

procedure TDonationDefaultsForm.SaveDefaults;
begin
  DonationDefaults.FieldByName('DonorId').AsInteger := FDonorId;

  if DonationKindDefaultCombo.ItemIndex <> -1 then
    DonationDefaults.FieldByName('DonationKind').AsString := DonationKindDefaultCombo.Value;

  if DonationKindDefaultCombo.Value <> TDonationUIUtils.OTHER then
    DonationDefaults.FieldByName('OtherDonationKind').AsString := OtherDonationKindDefaultEdit.Text;

  if DayOfMonthDefaultEdit.Text <> '' then
    DonationDefaults.FieldByName('UsualDayOfMonth').AsInteger := strtoint(DayOfMonthDefaultEdit.Text);

  if AmountDefaultEdit.Text <> '' then
    DonationDefaults.FieldByName('Amount').AsString := AmountDefaultEdit.Text;
  if PaymentMethodDefaultCombo.ItemIndex <> -1 then
    DonationDefaults.FieldByName('PaymentMethod').AsString := PaymentMethodDefaultCombo.Value;

  if AnalysisCode1DefaultCombo.ItemIndex <> -1 then
    DonationDefaults.FieldByName('AnalysisCode1').AsString := AnalysisCode1DefaultCombo.Items[AnalysisCode1DefaultCombo.ItemIndex];
  if AnalysisCode2DefaultCombo.ItemIndex <> -1 then
    DonationDefaults.FieldByName('AnalysisCode2').AsString := AnalysisCode2DefaultCombo.Items[AnalysisCode2DefaultCombo.ItemIndex];

  EssentialsManager.LookUpManager.ClearEmptyComboSelections(Self);
  DonationDefaults.Post;
end;

procedure TDonationDefaultsForm.PopulateForm;
begin
  DonationKindDefaultCombo.Value  := DonationDefaults.FieldByName('DonationKind').AsString;
  OtherDonationKindDefaultEdit.Text := DonationDefaults.FieldByName('OtherDonationKind').AsString;
  DetermineOtherDonationKindVisibility;
  DayOfMonthDefaultEdit.Text      := DonationDefaults.FieldByName('UsualDayOfMonth').AsString;
  AmountDefaultEdit.Text          := DonationDefaults.FieldByName('Amount').AsString;
  PaymentMethodDefaultCombo.Value := DonationDefaults.FieldByName('PaymentMethod').AsString;
  AnalysisCode1DefaultCombo.ItemIndex := AnalysisCode1DefaultCombo.Items.IndexOf(DonationDefaults.FieldByName('AnalysisCode1').AsString);
  AnalysisCode2DefaultCombo.ItemIndex := AnalysisCode2DefaultCombo.Items.IndexOf(DonationDefaults.FieldByName('AnalysisCode2').AsString);
end;

procedure TDonationDefaultsForm.DataChange(Sender: TObject);
begin
  SaveDefaultButton.Enabled := True;
end;

procedure TDonationDefaultsForm.DayOfMonthDefaultEditChange(Sender: TObject);
var
  lDay: integer;
begin
  try
    lDay := strtoint(DayOfMonthDefaultEdit.Text);
    if lDay <= 31 then
    begin
      SaveDefaultButton.Enabled := True;
    end
    else
      SaveDefaultButton.Enabled := False;
  except
    SaveDefaultButton.Enabled := False;
  end;
end;

procedure TDonationDefaultsForm.DayOfMonthDefaultEditKeyPress(Sender: TObject;
  var Key: Char);
begin
  if not (Key in ['0'..'9']) then
    Key := #0;
end;

procedure TDonationDefaultsForm.DetermineOtherDonationKindVisibility;
begin
  OtherDonationKindDefaultEdit.Visible := DonationKindDefaultCombo.Value = TDonationUIUtils.OTHER;
  TDocUtils.ShowHideElement('OtherDonationKindDefaultEditLabel', OtherDonationKindDefaultEdit.Visible);
end;

procedure TDonationDefaultsForm.Refresh;
begin
  if DonationDefaults.Locate('DonorId', FDonorId, []) then
  begin
    PopulateForm;
    DonationDefaults.Edit
  end
  else
    DonationDefaults.Insert;

  //DonationDefaults.Active := False;
  //DonationDefaults.Active := True;
end;

procedure TDonationDefaultsForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  PaymentMethodDefaultCombo := TLookupComboBox.Create('PaymentMethodDefaultCombo');
  AmountDefaultEdit := TEdit.Create('AmountDefaultEdit');
  DayOfMonthDefaultEdit := TEdit.Create('DayOfMonthDefaultEdit');
  DonationKindDefaultCombo := TLookupComboBox.Create('DonationKindDefaultCombo');
  SaveDefaultButton := TButton.Create('SaveDefaultButton');
  CancelDefaultButton := TButton.Create('CancelDefaultButton');
  CloseDefaultButton := TButton.Create('CloseDefaultButton');
  AnalysisCode1DefaultCombo := TDBComboBox.Create('AnalysisCode1DefaultCombo');
  AnalysisCode2DefaultCombo := TDBComboBox.Create('AnalysisCode2DefaultCombo');
  BankingReferenceDefaultCombo := TDBComboBox.Create('BankingReferenceDefaultCombo');
  OtherDonationKindDefaultEdit := TDBEdit.Create('OtherDonationKindDefaultEdit');
  DonationDefaults := TXDataWebDataSet.Create(Self);
  DonationDefaultsId := TIntegerField.Create(Self);
  DonationDefaultsDateAdded := TDateTimeField.Create(Self);
  DonationDefaultsAddedBy := TIntegerField.Create(Self);
  DonationDefaultsLastUpdatedBy := TIntegerField.Create(Self);
  DonationDefaultsLastUpdated := TDateTimeField.Create(Self);
  DonationDefaultsDonorId := TIntegerField.Create(Self);
  DonationDefaultsDonationKind := TStringField.Create(Self);
  DonationDefaultsUsualDayOfMonth := TIntegerField.Create(Self);
  DonationDefaultsAmount := TFloatField.Create(Self);
  DonationDefaultsPaymentMethod := TStringField.Create(Self);
  DonationDefaultsAnalysisCode1 := TStringField.Create(Self);
  DonationDefaultsAnalysisCode2 := TStringField.Create(Self);
  DonationDefaultsAnalysisCode3 := TStringField.Create(Self);
  DonationDefaultsBankingReference := TStringField.Create(Self);
  DonationDefaultsOtherDonationKind := TStringField.Create(Self);
  DonationDefaultsDataSource := TDataSource.Create(Self);

  PaymentMethodDefaultCombo.BeforeLoadDFMValues;
  AmountDefaultEdit.BeforeLoadDFMValues;
  DayOfMonthDefaultEdit.BeforeLoadDFMValues;
  DonationKindDefaultCombo.BeforeLoadDFMValues;
  SaveDefaultButton.BeforeLoadDFMValues;
  CancelDefaultButton.BeforeLoadDFMValues;
  CloseDefaultButton.BeforeLoadDFMValues;
  AnalysisCode1DefaultCombo.BeforeLoadDFMValues;
  AnalysisCode2DefaultCombo.BeforeLoadDFMValues;
  BankingReferenceDefaultCombo.BeforeLoadDFMValues;
  OtherDonationKindDefaultEdit.BeforeLoadDFMValues;
  DonationDefaults.BeforeLoadDFMValues;
  DonationDefaultsId.BeforeLoadDFMValues;
  DonationDefaultsDateAdded.BeforeLoadDFMValues;
  DonationDefaultsAddedBy.BeforeLoadDFMValues;
  DonationDefaultsLastUpdatedBy.BeforeLoadDFMValues;
  DonationDefaultsLastUpdated.BeforeLoadDFMValues;
  DonationDefaultsDonorId.BeforeLoadDFMValues;
  DonationDefaultsDonationKind.BeforeLoadDFMValues;
  DonationDefaultsUsualDayOfMonth.BeforeLoadDFMValues;
  DonationDefaultsAmount.BeforeLoadDFMValues;
  DonationDefaultsPaymentMethod.BeforeLoadDFMValues;
  DonationDefaultsAnalysisCode1.BeforeLoadDFMValues;
  DonationDefaultsAnalysisCode2.BeforeLoadDFMValues;
  DonationDefaultsAnalysisCode3.BeforeLoadDFMValues;
  DonationDefaultsBankingReference.BeforeLoadDFMValues;
  DonationDefaultsOtherDonationKind.BeforeLoadDFMValues;
  DonationDefaultsDataSource.BeforeLoadDFMValues;
  try
    Caption := 'Donor Defaults';
    ElementPosition := epIgnore;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    PaymentMethodDefaultCombo.SetParentComponent(Self);
    PaymentMethodDefaultCombo.Name := 'PaymentMethodDefaultCombo';
    PaymentMethodDefaultCombo.Left := 22;
    PaymentMethodDefaultCombo.Top := 144;
    PaymentMethodDefaultCombo.Width := 419;
    PaymentMethodDefaultCombo.Height := 22;
    PaymentMethodDefaultCombo.ElementClassName := 'form-select';
    PaymentMethodDefaultCombo.ElementPosition := epIgnore;
    PaymentMethodDefaultCombo.HeightStyle := ssAuto;
    PaymentMethodDefaultCombo.HeightPercent := 100.000000000000000000;
    PaymentMethodDefaultCombo.WidthStyle := ssAuto;
    PaymentMethodDefaultCombo.WidthPercent := 100.000000000000000000;
    SetEvent(PaymentMethodDefaultCombo, Self, 'OnChange', 'DataChange');
    PaymentMethodDefaultCombo.ItemIndex := -1;
    AmountDefaultEdit.SetParentComponent(Self);
    AmountDefaultEdit.Name := 'AmountDefaultEdit';
    AmountDefaultEdit.Left := 26;
    AmountDefaultEdit.Top := 104;
    AmountDefaultEdit.Width := 121;
    AmountDefaultEdit.Height := 22;
    AmountDefaultEdit.ChildOrder := 10;
    AmountDefaultEdit.ElementClassName := 'form-control';
    AmountDefaultEdit.ElementPosition := epIgnore;
    AmountDefaultEdit.HeightStyle := ssAuto;
    AmountDefaultEdit.HeightPercent := 100.000000000000000000;
    AmountDefaultEdit.WidthStyle := ssAuto;
    AmountDefaultEdit.WidthPercent := 100.000000000000000000;
    SetEvent(AmountDefaultEdit, Self, 'OnChange', 'DataChange');
    SetEvent(AmountDefaultEdit, Self, 'OnKeyPress', 'AmountDefaultEditKeyPress');
    DayOfMonthDefaultEdit.SetParentComponent(Self);
    DayOfMonthDefaultEdit.Name := 'DayOfMonthDefaultEdit';
    DayOfMonthDefaultEdit.Left := 24;
    DayOfMonthDefaultEdit.Top := 64;
    DayOfMonthDefaultEdit.Width := 121;
    DayOfMonthDefaultEdit.Height := 22;
    DayOfMonthDefaultEdit.ChildOrder := 10;
    DayOfMonthDefaultEdit.ElementClassName := 'form-control';
    DayOfMonthDefaultEdit.ElementPosition := epIgnore;
    DayOfMonthDefaultEdit.HeightStyle := ssAuto;
    DayOfMonthDefaultEdit.HeightPercent := 100.000000000000000000;
    DayOfMonthDefaultEdit.MaxLength := 2;
    DayOfMonthDefaultEdit.WidthStyle := ssAuto;
    DayOfMonthDefaultEdit.WidthPercent := 100.000000000000000000;
    SetEvent(DayOfMonthDefaultEdit, Self, 'OnChange', 'DayOfMonthDefaultEditChange');
    SetEvent(DayOfMonthDefaultEdit, Self, 'OnKeyPress', 'DayOfMonthDefaultEditKeyPress');
    DonationKindDefaultCombo.SetParentComponent(Self);
    DonationKindDefaultCombo.Name := 'DonationKindDefaultCombo';
    DonationKindDefaultCombo.Left := 22;
    DonationKindDefaultCombo.Top := 24;
    DonationKindDefaultCombo.Width := 419;
    DonationKindDefaultCombo.Height := 22;
    DonationKindDefaultCombo.ElementClassName := 'form-select';
    DonationKindDefaultCombo.ElementPosition := epIgnore;
    DonationKindDefaultCombo.HeightPercent := 100.000000000000000000;
    DonationKindDefaultCombo.WidthPercent := 100.000000000000000000;
    SetEvent(DonationKindDefaultCombo, Self, 'OnChange', 'DonationKindDefaultComboChange');
    DonationKindDefaultCombo.ItemIndex := -1;
    SaveDefaultButton.SetParentComponent(Self);
    SaveDefaultButton.Name := 'SaveDefaultButton';
    SaveDefaultButton.Left := 251;
    SaveDefaultButton.Top := 304;
    SaveDefaultButton.Width := 96;
    SaveDefaultButton.Height := 25;
    SaveDefaultButton.Caption := 'Save';
    SaveDefaultButton.ChildOrder := 6;
    SaveDefaultButton.ElementClassName := 'btn';
    SaveDefaultButton.HeightPercent := 100.000000000000000000;
    SaveDefaultButton.WidthPercent := 100.000000000000000000;
    SetEvent(SaveDefaultButton, Self, 'OnClick', 'SaveDefaultButtonClick');
    CancelDefaultButton.SetParentComponent(Self);
    CancelDefaultButton.Name := 'CancelDefaultButton';
    CancelDefaultButton.Left := 149;
    CancelDefaultButton.Top := 304;
    CancelDefaultButton.Width := 96;
    CancelDefaultButton.Height := 25;
    CancelDefaultButton.Caption := 'Cancel';
    CancelDefaultButton.ChildOrder := 6;
    CancelDefaultButton.ElementClassName := 'btn';
    CancelDefaultButton.HeightPercent := 100.000000000000000000;
    CancelDefaultButton.WidthPercent := 100.000000000000000000;
    SetEvent(CancelDefaultButton, Self, 'OnClick', 'CancelDefaultButtonClick');
    CloseDefaultButton.SetParentComponent(Self);
    CloseDefaultButton.Name := 'CloseDefaultButton';
    CloseDefaultButton.Left := 353;
    CloseDefaultButton.Top := 304;
    CloseDefaultButton.Width := 96;
    CloseDefaultButton.Height := 25;
    CloseDefaultButton.Caption := 'Close';
    CloseDefaultButton.ChildOrder := 6;
    CloseDefaultButton.ElementClassName := 'btn';
    CloseDefaultButton.ElementFont := efCSS;
    CloseDefaultButton.ElementPosition := epIgnore;
    CloseDefaultButton.HeightStyle := ssAuto;
    CloseDefaultButton.HeightPercent := 100.000000000000000000;
    CloseDefaultButton.WidthStyle := ssAuto;
    CloseDefaultButton.WidthPercent := 100.000000000000000000;
    SetEvent(CloseDefaultButton, Self, 'OnClick', 'CloseDefaultButtonClick');
    AnalysisCode1DefaultCombo.SetParentComponent(Self);
    AnalysisCode1DefaultCombo.Name := 'AnalysisCode1DefaultCombo';
    AnalysisCode1DefaultCombo.Left := 22;
    AnalysisCode1DefaultCombo.Top := 184;
    AnalysisCode1DefaultCombo.Width := 419;
    AnalysisCode1DefaultCombo.Height := 23;
    AnalysisCode1DefaultCombo.ElementClassName := 'form-select';
    AnalysisCode1DefaultCombo.HeightPercent := 100.000000000000000000;
    AnalysisCode1DefaultCombo.Text := 'AnalysisCode1DefaultCombo';
    AnalysisCode1DefaultCombo.WidthPercent := 100.000000000000000000;
    AnalysisCode1DefaultCombo.ItemIndex := -1;
    AnalysisCode1DefaultCombo.DataField := 'AnalysisCode1';
    AnalysisCode1DefaultCombo.DataSource := DonationDefaultsDataSource;
    AnalysisCode2DefaultCombo.SetParentComponent(Self);
    AnalysisCode2DefaultCombo.Name := 'AnalysisCode2DefaultCombo';
    AnalysisCode2DefaultCombo.Left := 22;
    AnalysisCode2DefaultCombo.Top := 224;
    AnalysisCode2DefaultCombo.Width := 419;
    AnalysisCode2DefaultCombo.Height := 23;
    AnalysisCode2DefaultCombo.ElementClassName := 'form-select';
    AnalysisCode2DefaultCombo.HeightPercent := 100.000000000000000000;
    AnalysisCode2DefaultCombo.Text := 'AnalysisCode2DefaultCombo';
    AnalysisCode2DefaultCombo.WidthPercent := 100.000000000000000000;
    AnalysisCode2DefaultCombo.ItemIndex := -1;
    AnalysisCode2DefaultCombo.DataField := 'AnalysisCode2';
    AnalysisCode2DefaultCombo.DataSource := DonationDefaultsDataSource;
    BankingReferenceDefaultCombo.SetParentComponent(Self);
    BankingReferenceDefaultCombo.Name := 'BankingReferenceDefaultCombo';
    BankingReferenceDefaultCombo.Left := 22;
    BankingReferenceDefaultCombo.Top := 264;
    BankingReferenceDefaultCombo.Width := 419;
    BankingReferenceDefaultCombo.Height := 23;
    BankingReferenceDefaultCombo.ElementClassName := 'form-select';
    BankingReferenceDefaultCombo.HeightPercent := 100.000000000000000000;
    BankingReferenceDefaultCombo.Text := 'BankingReferenceDefaultCombo';
    BankingReferenceDefaultCombo.WidthPercent := 100.000000000000000000;
    BankingReferenceDefaultCombo.ItemIndex := -1;
    BankingReferenceDefaultCombo.DataField := 'BankingReference';
    BankingReferenceDefaultCombo.DataSource := DonationDefaultsDataSource;
    OtherDonationKindDefaultEdit.SetParentComponent(Self);
    OtherDonationKindDefaultEdit.Name := 'OtherDonationKindDefaultEdit';
    OtherDonationKindDefaultEdit.Left := 151;
    OtherDonationKindDefaultEdit.Top := 64;
    OtherDonationKindDefaultEdit.Width := 290;
    OtherDonationKindDefaultEdit.Height := 22;
    OtherDonationKindDefaultEdit.AutoSelect := False;
    OtherDonationKindDefaultEdit.ChildOrder := 17;
    OtherDonationKindDefaultEdit.ElementClassName := 'form-control';
    OtherDonationKindDefaultEdit.ElementFont := efCSS;
    OtherDonationKindDefaultEdit.ElementPosition := epIgnore;
    OtherDonationKindDefaultEdit.HeightStyle := ssAuto;
    OtherDonationKindDefaultEdit.HeightPercent := 100.000000000000000000;
    OtherDonationKindDefaultEdit.Visible := False;
    OtherDonationKindDefaultEdit.WidthStyle := ssAuto;
    OtherDonationKindDefaultEdit.WidthPercent := 100.000000000000000000;
    SetEvent(OtherDonationKindDefaultEdit, Self, 'OnExit', 'OtherDonationKindDefaultEditExit');
    OtherDonationKindDefaultEdit.DataField := 'OtherDonationKind';
    OtherDonationKindDefaultEdit.DataSource := DonationDefaultsDataSource;
    DonationDefaults.SetParentComponent(Self);
    DonationDefaults.Name := 'DonationDefaults';
    DonationDefaults.AfterOpen := DonationDefaultsAfterOpen;
    DonationDefaults.AfterPost := DonationDefaultsAfterPost;
    DonationDefaults.EntitySetName := 'DonationDefaults';
    DonationDefaults.Connection := MainData.DataConnection;
    DonationDefaults.Left := 496;
    DonationDefaults.Top := 400;
    DonationDefaultsId.SetParentComponent(DonationDefaults);
    DonationDefaultsId.Name := 'DonationDefaultsId';
    DonationDefaultsId.FieldName := 'Id';
    DonationDefaultsDateAdded.SetParentComponent(DonationDefaults);
    DonationDefaultsDateAdded.Name := 'DonationDefaultsDateAdded';
    DonationDefaultsDateAdded.FieldName := 'DateAdded';
    DonationDefaultsAddedBy.SetParentComponent(DonationDefaults);
    DonationDefaultsAddedBy.Name := 'DonationDefaultsAddedBy';
    DonationDefaultsAddedBy.FieldName := 'AddedBy';
    DonationDefaultsLastUpdatedBy.SetParentComponent(DonationDefaults);
    DonationDefaultsLastUpdatedBy.Name := 'DonationDefaultsLastUpdatedBy';
    DonationDefaultsLastUpdatedBy.FieldName := 'LastUpdatedBy';
    DonationDefaultsLastUpdated.SetParentComponent(DonationDefaults);
    DonationDefaultsLastUpdated.Name := 'DonationDefaultsLastUpdated';
    DonationDefaultsLastUpdated.FieldName := 'LastUpdated';
    DonationDefaultsDonorId.SetParentComponent(DonationDefaults);
    DonationDefaultsDonorId.Name := 'DonationDefaultsDonorId';
    DonationDefaultsDonorId.FieldName := 'DonorId';
    DonationDefaultsDonationKind.SetParentComponent(DonationDefaults);
    DonationDefaultsDonationKind.Name := 'DonationDefaultsDonationKind';
    DonationDefaultsDonationKind.FieldName := 'DonationKind';
    DonationDefaultsDonationKind.Size := 30;
    DonationDefaultsUsualDayOfMonth.SetParentComponent(DonationDefaults);
    DonationDefaultsUsualDayOfMonth.Name := 'DonationDefaultsUsualDayOfMonth';
    DonationDefaultsUsualDayOfMonth.FieldName := 'UsualDayOfMonth';
    DonationDefaultsAmount.SetParentComponent(DonationDefaults);
    DonationDefaultsAmount.Name := 'DonationDefaultsAmount';
    DonationDefaultsAmount.FieldName := 'Amount';
    DonationDefaultsPaymentMethod.SetParentComponent(DonationDefaults);
    DonationDefaultsPaymentMethod.Name := 'DonationDefaultsPaymentMethod';
    DonationDefaultsPaymentMethod.FieldName := 'PaymentMethod';
    DonationDefaultsAnalysisCode1.SetParentComponent(DonationDefaults);
    DonationDefaultsAnalysisCode1.Name := 'DonationDefaultsAnalysisCode1';
    DonationDefaultsAnalysisCode1.FieldName := 'AnalysisCode1';
    DonationDefaultsAnalysisCode1.Size := 75;
    DonationDefaultsAnalysisCode2.SetParentComponent(DonationDefaults);
    DonationDefaultsAnalysisCode2.Name := 'DonationDefaultsAnalysisCode2';
    DonationDefaultsAnalysisCode2.FieldName := 'AnalysisCode2';
    DonationDefaultsAnalysisCode2.Size := 75;
    DonationDefaultsAnalysisCode3.SetParentComponent(DonationDefaults);
    DonationDefaultsAnalysisCode3.Name := 'DonationDefaultsAnalysisCode3';
    DonationDefaultsAnalysisCode3.FieldName := 'AnalysisCode3';
    DonationDefaultsAnalysisCode3.Size := 75;
    DonationDefaultsBankingReference.SetParentComponent(DonationDefaults);
    DonationDefaultsBankingReference.Name := 'DonationDefaultsBankingReference';
    DonationDefaultsBankingReference.FieldName := 'BankingReference';
    DonationDefaultsOtherDonationKind.SetParentComponent(DonationDefaults);
    DonationDefaultsOtherDonationKind.Name := 'DonationDefaultsOtherDonationKind';
    DonationDefaultsOtherDonationKind.FieldName := 'OtherDonationKind';
    DonationDefaultsDataSource.SetParentComponent(Self);
    DonationDefaultsDataSource.Name := 'DonationDefaultsDataSource';
    DonationDefaultsDataSource.DataSet := DonationDefaults;
    SetEvent(DonationDefaultsDataSource, Self, 'OnDataChange', 'DonationDefaultsDataSourceDataChange');
    DonationDefaultsDataSource.Left := 352;
    DonationDefaultsDataSource.Top := 400;
  finally
    PaymentMethodDefaultCombo.AfterLoadDFMValues;
    AmountDefaultEdit.AfterLoadDFMValues;
    DayOfMonthDefaultEdit.AfterLoadDFMValues;
    DonationKindDefaultCombo.AfterLoadDFMValues;
    SaveDefaultButton.AfterLoadDFMValues;
    CancelDefaultButton.AfterLoadDFMValues;
    CloseDefaultButton.AfterLoadDFMValues;
    AnalysisCode1DefaultCombo.AfterLoadDFMValues;
    AnalysisCode2DefaultCombo.AfterLoadDFMValues;
    BankingReferenceDefaultCombo.AfterLoadDFMValues;
    OtherDonationKindDefaultEdit.AfterLoadDFMValues;
    DonationDefaults.AfterLoadDFMValues;
    DonationDefaultsId.AfterLoadDFMValues;
    DonationDefaultsDateAdded.AfterLoadDFMValues;
    DonationDefaultsAddedBy.AfterLoadDFMValues;
    DonationDefaultsLastUpdatedBy.AfterLoadDFMValues;
    DonationDefaultsLastUpdated.AfterLoadDFMValues;
    DonationDefaultsDonorId.AfterLoadDFMValues;
    DonationDefaultsDonationKind.AfterLoadDFMValues;
    DonationDefaultsUsualDayOfMonth.AfterLoadDFMValues;
    DonationDefaultsAmount.AfterLoadDFMValues;
    DonationDefaultsPaymentMethod.AfterLoadDFMValues;
    DonationDefaultsAnalysisCode1.AfterLoadDFMValues;
    DonationDefaultsAnalysisCode2.AfterLoadDFMValues;
    DonationDefaultsAnalysisCode3.AfterLoadDFMValues;
    DonationDefaultsBankingReference.AfterLoadDFMValues;
    DonationDefaultsOtherDonationKind.AfterLoadDFMValues;
    DonationDefaultsDataSource.AfterLoadDFMValues;
  end;
end;

end.
